(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('joinus', {
            parent: 'app',
            url: '/joinus',
            data: {
                authorities: [],
                pageTitle: 'global.menu.suggestions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/join-us/join-us.html',
                    controller: 'JoinUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('join-us');
                    return $translate.refresh();
                }]
            }
        })
        .state('joinusInterns', {
            parent: 'joinus',
            url: '/interns/reviews',
            data: {
                authorities: [],
                pageTitle: 'global.menu.suggestions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/join-us/join-us-interns.html',
                    controller: 'JoinUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('join-us');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
